import S3FileUploader from './s3_file_uploader';

// the platform-standard visitor upload: presign at MDMS /forms/s3/sign, PUT direct to S3.
// MDMS ingests the resulting URL anywhere AcceleratedUpload.is? matches (raw_form_submit.rb).
const formsS3Uploader = file =>
  new S3FileUploader(file, {
    signingUrl: '/forms/s3/sign',
    signingUrlMethod: 'GET',
    accept: '*',
    // must stay truthy: react-s3-uploader sends x-amz-acl: public-read when it is not
    uploadRequestHeaders: {},
    scrubFilename: name => name.replace(/[^\w\d_\-.]+/gi, ''),
    server: MDMS_URL,
  });

export default formsS3Uploader;
